import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export const Stats = () => {
  const { t } = useLang();
  return (
    <section data-testid="stats-section" className="relative border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {t.stats.map((s, i) => (
          <motion.div
            key={i}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="text-center"
          >
            <div className="font-outfit text-3xl sm:text-4xl font-extrabold text-gradient">
              {s.value}
            </div>
            <div className="mt-1 text-sm text-slate-400">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
